import { useFormContext } from "react-hook-form";

import Grid from "@mui/material/Grid";

import InputFormField from "components/input-form-field";
import SelectFormField from "components/select-form-field";
import { BATTERY_COLORS } from "constants/products";

import { AddMasterProductFormValues } from "../add-master-product-form.component";

export default function BatterySpecificationForm() {
  const { control } = useFormContext<AddMasterProductFormValues>();
  return (
    <Grid
      container
      width="100%"
      sx={{ pb: 4 }}
      columnSpacing={2}
      rowSpacing={4}
    >
      <Grid item xs={4}>
        <InputFormField
          name="specification.type"
          label="Type"
          control={control}
          sx={{ ml: 0 }}
        />
      </Grid>
      <Grid item xs={4}>
        <SelectFormField
          name="specification.color"
          label="Color"
          control={control}
          options={BATTERY_COLORS.getOptions()}
          dropDownZIndex={1502}
        />
      </Grid>
      <Grid item xs={4}>
        <InputFormField
          name="specification.warranty_months"
          label="Warranty Months"
          type="number"
          inputProps={{ min: 0 }}
          control={control}
          sx={{ ml: 0 }}
        />
      </Grid>
    </Grid>
  );
}
